import type { ImageWithMetadata } from 'types/capi/article';

import ImpressionEvent, { type ImpressionType } from './ImpressionEvent';

export type ImageGridDisplayType = 'full-bleed' | 'grid';

export type EditorialImageImpressionProperties = {
  destination_path?: string;
  destination_url?: string;
  display_type: ImageGridDisplayType;
  image_url: string;
  module_position?: number;
  module_type: 'image-grid';
  position: number;
  retailer_id?: string;
};

type EventData = {
  displayType: ImageGridDisplayType;
  guestId?: string;
  isBot: boolean;
  item: ImageWithMetadata;
  modulePosition?: number;
  position: number;
};

class EditorialImageImpressionEvent extends ImpressionEvent<
  EventData,
  EditorialImageImpressionProperties
> {
  protected get impressionType(): ImpressionType {
    return 'editorial_image';
  }

  protected getImpressionProperties(): EditorialImageImpressionProperties {
    const { displayType, item, modulePosition, position } = this.data;
    const { cta, desktop, mobile } = item;
    const externalCta = cta?.type === 'external' ? cta : undefined;

    return {
      destination_path: cta?.type === 'internal' ? cta.path : undefined,
      destination_url: externalCta?.url,
      display_type: displayType,
      image_url: mobile.url || desktop.url,
      module_position: modulePosition,
      module_type: 'image-grid',
      position,
      retailer_id: externalCta?.affiliate?.canonical_id
    };
  }
}

export default EditorialImageImpressionEvent;
